<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img src="@/assets/admin-icon/organization-active.svg" />
          <pathViewer></pathViewer>
        </div>
        <div class="ribbon-options">
          <RoleManagement></RoleManagement>
        </div>
      </div>
      <div class="page-options"></div>
    </div>
    <div class="page-body">
      <div class="tabs-widget">
        <div class="profile-widget">
          <img
            v-if="user.company_info.company_logo"
            :src="$fullUrl('images/profiles/' + user.company_info.company_logo)"
          />
          <img v-else src="@/assets/icons/logo_avatar.svg" />
          <h2 class="company-name">
            {{ user.company_info.company_name | validate }}
          </h2>
          <p>{{ user.company_info.address | validate }}</p>
        </div>
        <div class="tabs-links">
          <div
            class="tab"
            style="justify-content: flex-start"
            :class="{ active: tab_type == 'public' }"
            @click="switchTab('public')"
          >
            <span class="name">Public information</span>
            <span class="icon">
              <img
                v-if="tab_type == 'public'"
                src="@/assets/icons/consultant-profile-icons/general-infos-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/general-infos.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{
              active:
                tab_type == 'consultants' || $route.name == 'manage_consultant',
            }"
            @click="switchTab('consultants')"
          >
            <span class="name">Consultants</span>
            <span class="icon">
              <img
                v-if="tab_type == 'consultants'"
                src="@/assets/icons/consultant-profile-icons/consultants-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/consultants.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: tab_type == 'project' }"
            @click="switchTab('project')"
          >
            <span class="name">Projects</span>
            <span class="icon">
              <img
                v-if="tab_type == 'project'"
                src="@/assets/icons/consultant-profile-icons/projects-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/projects.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: tab_type == 'skills' }"
            @click="switchTab('skills')"
          >
            <span class="name">Skills</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/skills.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{
              active: tab_type == 'teams' || $route.name == 'view-team',
            }"
            @click="switchTab('teams')"
          >
            <span class="name">Teams</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/skills.svg"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="tab-body">
        <!-- General info -->
        <general-information v-if="tab_type == 'public'" />
        <!-- End of genelar info -->

        <!-- Consultants -->
        <Consultants v-if="tab_type == 'consultants'" />
        <!-- End of Consultants -->

        <!-- Skills -->
        <Skills v-if="tab_type == 'skills'" />
        <!-- End of Skills -->

        <!-- Projects -->
        <Projects v-if="tab_type == 'project'" />
        <!-- End of Projects -->

        <!-- View consultant -->
        <ManageConsultant v-if="$route.params.company_id && $route.params.id" />

        <!-- Teams -->
        <Teams v-if="tab_type == 'teams'"></Teams>

        <!-- ViewTeam -->
        <ViewTeam v-if="$route.params.team_id"></ViewTeam>
      </div>
    </div>
  </div>
</template>
<script>
import generalInformation from "@/components/Company/generalInformation.vue";
import Consultants from "@/components/Company/Consultants.vue";
import Skills from "@/components/Company/Skills.vue";
import Projects from "@/components/Company/Projects.vue";
import Assignments from "@/components/Company/Assignments.vue";
import Pitches from "@/components/Company/Pitches.vue";
import Teams from "@/components/Company/Teams.vue";
import ManageConsultant from "@/components/Company/ManageConsultant.vue";
import ViewTeam from "@/components/Company/ViewTeam.vue";

export default {
  name: "dashboard",
  components: {
    generalInformation,
    Consultants,
    Skills,
    Projects,
    Assignments,
    Pitches,
    Teams,
    ManageConsultant,
    ViewTeam,
  },
  data() {
    return {
      tab_type: "public",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
      },
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.tab_type = val;
    },
  },
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Organization",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.$store
      .dispatch("GET_ME_USER_COMPANY")
      .then((responce) => {
        vm.user = responce.data;
      })
      .catch((error) => {});
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    }
  },
  methods: {
    onScoll({ target }) {
      // Modify header according to profile scoll
      let vm = this;
      vm.isScoll = true;
    },
    switchTab(type) {
      let vm = this;
      let path = [
        {
          label: "Organization",
        },
        {
          label: type,
          active: true,
        },
      ];
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({ name: "organization", params: { type: type } })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    height: 89px;
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 20px;
            height: 20px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      min-height: 50px;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 97px);
    width: 100%;
    display: grid;
    overflow-x: hidden;
    overflow: hidden;
    position: relative;
    grid-template-columns: 200px calc(99% - 200px);
    padding: 0px 0px;
    padding-left: 8px;
    padding-top: 10px;
    grid-column-gap: 8px;
    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: 100%;
      padding-left: 0px;
    }
    .tabs-widget {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      border-bottom: 1px solid #efefef;
      border-radius: 5px;
      height: calc(100vh - 111px);

      .profile-widget {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        margin-bottom: 20px;
        height: 168px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          color: #0884af;
          object-fit: cover;
        }
        h2 {
          margin: 0px;
          font-size: 20px;
          margin: 10px 0px;
          color: #0884af;
        }
        p {
          color: #707070;
          margin: 0px;
          text-align: center;
        }
      }
      .tabs-links {
        overflow-y: auto;
        height: calc(100% - 168px);
        @media (min-width: 300px) and (max-width: 630px) {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: unset;
          overflow-y: unset;
        }
        .tab {
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
          }
          .name {
            display: block;
            font-size: 13px;
            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }
          .icon {
            display: none;
            background: #dedede;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              display: flex;
            }
            img {
              width: 22.9px;
            }
          }
        }
        .tab.active {
          color: #fff;
          background: #0884af;
          font-weight: 800;
          @media (min-width: 300px) and (max-width: 630px) {
            background: #fff;
          }
          .icon {
            background: #1890a9;
          }
        }
        .tab:hover {
          color: #fff;
          background: #0884af;
          @media (min-width: 300px) and (max-width: 630px) {
            background: #fff;
          }
        }
      }
    }
    .tab-body {
      width: 100%;
      padding: 0px !important;
      height: calc(100vh - 111px);
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
